export function useFocusReload () {
  const handleFocus = () => {
    const hasReloaded = sessionStorage.getItem("hasReloaded");
    if (!hasReloaded || hasReloaded === "false") {
      sessionStorage.setItem("hasReloaded", "true");
      window.removeEventListener("focus", handleFocus);
      window.location.reload();
    }
  };

  window.addEventListener("focus", handleFocus);
  handleFocus();
}